import React, { useEffect, useState } from "react";
import { ChartBox } from "./";
import http from "../../../../../services/http";
import { CHART_FILTERS } from "../../../../../constant";
import { generateChartConfig } from "../../../../../utils";

function ActiveUsers() {
  // STATES
  const [selectedFilter, setselectedFilter] = useState(CHART_FILTERS[0].value);
  const [totalUsers, settotalUsers] = useState(0);
  const [data, setData] = useState([]);

  // HELPERS
  const getStats = async () => {
    const { data } = await http.get(`active-users/${selectedFilter}`);
    setData(data.result);
    settotalUsers(data.totalUsers);
  };

  // CONST VALS
  const dayFilter = selectedFilter === CHART_FILTERS[0].value;
  const category = dayFilter ? "login_time" : "login_date";
  const categories = data.map((item) => item[category]);
  const chartData = data.map((item) => item.user_count);
  const chartOptions = generateChartConfig({
    categories,
    isDay: dayFilter,
    totalUsers,
  });

  // HANDLERS
  const setFilter = (val) => {
    setselectedFilter(val);
  };

  // HOOKS
  useEffect(() => {
    getStats();
  }, [selectedFilter]);

  return (
    <ChartBox
      title="Active Users"
      data={chartData}
      config={chartOptions}
      selectedFilter={selectedFilter}
      setFilter={setFilter}
    />
  );
}

export default ActiveUsers;
